import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Page menu component which expects link elements through ng content
 */
@Component({
  selector: 'atx-page-menu',
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageMenuComponent {
  @Input()
  public wrap = false;

  @Input()
  public set showBurgerMenuOnMobile(value: boolean) {
    this.showBurgerMenuOnMobile$$.next(value);
  }

  public show$ = new BehaviorSubject(false);
  private showBurgerMenuOnMobile$$ = new BehaviorSubject(true);
  public showBurgerMenu$ = combineLatest([
    atxIsMobile$,
    this.showBurgerMenuOnMobile$$,
  ]).pipe(
    map(([isMobile, showBurgerOnMobile]) => isMobile && showBurgerOnMobile),
  );

  public open() {
    this.show$.next(true);
  }

  public close() {
    this.show$.next(false);
  }
}
